import { createRoot } from 'react-dom/client';
import './index.css';
createRoot(document.getElementById('root') as HTMLElement).render(
  <div>
    <div>Editor</div>
    <div>running</div>
  </div>
);
